import { Component, OnInit } from "@angular/core";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../i18n/it";
import { AuthenticationService } from "../../../../auth/service";
import { IDatatableConfig } from "../../../../auth/models/datatable";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IFigure } from "app/auth/models/figures";

@Component({
  selector: "app-figures-list",
  templateUrl: "./figures-list.component.html",
  styleUrls: ["./figures-list.component.scss"],
})
export class FiguresListComponent implements OnInit {
  public config: IDatatableConfig;

  public figures: IFigure[] = [];

  public new_figure: string = "";

  public currentFigure: IFigure;

  public contentHeader: IContentHeader;

  public searchKeyword: string = "";

  public tableLimit: number = 10;

  public showModalError: boolean = false;

  constructor(
    public _figureService: UserFigureService,
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: italian.data.MENU.FIGURES,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.FIGURES,
            isLink: false,
          },
        ],
      },
    };
    this.config = {
      exportable: false,
      searchable: false,
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 50,
      footerHeight: 60,
      scrollbarH: true,
      columns: [
        {
          value: "name",
          text: italian.data.FIRSTNAME,
          width: 500,
          sortable: true,
        },
        {
          value: "users",
          text: italian.data.NUMBER_EMPOLYEE,
          width: 400,
          sortable: true,
        },
      ],
      urls: {
        add: true,
        edit: true,
        remove: true,
      },
    };

    if (this._utilService.isMobile || this._utilService.isTablet) {
      this.config.columns.pop();
      this.config.columns[0].width = null;
      this.config.scrollbarH = false;
      this.config.rowHeight = 110;
    }

    await this.loadFigure();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadFigure() {
    this.figures = await this._figureService.getList();
    this.figures = this.figures.sort((a, b) => (a.name > b.name ? 1 : -1));
  }

  figuresList() {
    let items: IFigure[] = this.figures;

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.figures.filter((item: IFigure) => item.name.toLowerCase().includes(keywords));
    }

    return items;
  }

  async addNewFigure() {
    if (!this._authenticationService.hasCapability("create_user_figure")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.new_figure) {
      this.new_figure = this.new_figure.trim();
    }

    if (!this.new_figure || this.new_figure.length < 1) {
      this.showModalError = true;
      return false;
    }

    const data: { name: string } = {
      name: this.new_figure,
    };
    this._utilService.showLoading();
    await this._figureService
      .create(data)
      .then(async () => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FIGURE" });
        await this.loadFigure();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPLOAD_FIGURE" });
      });
  }

  async deleteFigure(currentFigure) {
    if (!this._authenticationService.hasCapability("delete_user_figure")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentFigure.name;
    if (currentFigure.users < 1) {
      this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._figureService.delete(currentFigure.id);
          await this._utilService.showSWALSuccess({ text: "SUCCES_DELETE_FIGURE" });
          await this.loadFigure();
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    } else {
      await this._utilService.showSWALError({ text: "USED_FIGURE_TEXT" });
    }
  }

  async editCurrentFigure() {
    if (!this._authenticationService.hasCapability("edit_user_figure")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.currentFigure.name) {
      this.currentFigure.name = this.currentFigure.name.trim();
    }

    if (!this.currentFigure.name || this.currentFigure.name.length < 1) {
      this.showModalError = true;
      return false;
    }

    const data: { name: string } = {
      name: this.currentFigure.name,
    };
    this._utilService.showLoading();
    await this._figureService
      .update(this.currentFigure.id, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_FIGURE" });
        this._modalService.dismissAll();
        await this.loadFigure();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_FIGURE" });
      });
  }

  modalOpen(modalBasic, currentFigure) {
    this.new_figure = "";
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.currentFigure = JSON.parse(JSON.stringify(currentFigure));
    this.showModalError = false;
  }
}
